/*
 * @Author: Tahiti
 * @Date: 2025-12-10 18:48:29
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-11 13:38:12
 * @Description:
 * @FilePath: /weryai-web/locales/modules/profiles.ts
 */
export default {
    zh: {
        email: '邮箱',
        avatar: '头像',
        nick_name: '昵称',
        gender: '性别',
        gender_male: '男',
        gender_female: '女',
        gender_other: '其他',
        submit: '提交',
        submitting: '提交中',
        editAvatar: '编辑头像',
        submitSuccess: '修改成功',
        tip: '提示',
        cancel: '取消',
        confirm: '确定',
        optional: '选填',
        deleteAccount: '注销账号',
        deleteAccountConfirm: '确定要注销账号吗？注销后数据将无法恢复。',
        deleteAccountTip: '请前往 账户设置 → 安全中心 提交注销申请。',
    },
    en: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Nick Name',
        gender: 'Gender',
        gender_male: 'Male',
        gender_female: 'Female',
        gender_other: 'Other',
        submit: 'Submit',
        submitting: 'Submitting',
        editAvatar: 'Edit Avatar',
        submitSuccess: 'Submit Success',
        tip: 'Tip',
        cancel: 'Cancel',
        confirm: 'Confirm',
        optional: 'Optional',
        deleteAccount: 'Delete account',
        deleteAccountConfirm: 'Are you sure you want to delete your account? Data cannot be recovered after deletion.',
        deleteAccountTip: 'Please go to Account settings → Security center to submit a deletion request.',
    },
    ja: {
        email: 'メールアドレス',
        avatar: 'アバター',
        nick_name: 'ニックネーム',
        gender: '性別',
        gender_male: '男',
        gender_female: '女',
        gender_other: 'その他',
        submit: '送信',
        submitting: '送信中',
        editAvatar: 'アバターを編集',
        submitSuccess: '送信成功',
        tip: '提示',
        cancel: 'キャンセル',
        confirm: '確認',
        optional: '任意',
        deleteAccount: 'アカウント削除',
        deleteAccountConfirm: 'アカウントを削除してもよろしいですか？削除後はデータを復元できません。',
        deleteAccountTip: 'アカウント設定 → セキュリティセンターで削除申請を提出してください。',
    },
    ko: {
        email: '이메일',
        avatar: '아바타',
        nick_name: '닉네임',
        gender: '성별',
        gender_male: '남',
        gender_female: '여',
        gender_other: '기타',
        submit: '제출',
        submitting: '제출중',
        editAvatar: '아바타 수정',
        submitSuccess: '제출 성공',
        tip: '팁',
            cancel: '', // Pending alignment
            confirm: '', // Pending alignment
        optional: '선택',
        deleteAccount: '계정 삭제',
        deleteAccountConfirm: '정말 계정을 삭제하시겠습니까? 삭제 후 데이터는 복구할 수 없습니다.',
        deleteAccountTip: '계정 설정 → 보안 센터에서 삭제 신청을 제출해 주세요.',
    },
    tw: {
        email: '信箱',
        avatar: '頭像',
        nick_name: '暱稱',
        gender: '性別',
        gender_male: '男',
        gender_female: '女',
        gender_other: '其他',
        submit: '提交',
        submitting: '提交中',
        editAvatar: '編輯頭像',
        submitSuccess: '修改成功',
        tip: '提示',
        cancel: '取消',
        confirm: '確定',
        optional: '选填',
        deleteAccount: '註銷帳號',
        deleteAccountConfirm: '確定要註銷帳號嗎？註銷後資料將無法恢復。',
        deleteAccountTip: '請前往 帳戶設定 → 安全中心 提交註銷申請。',
    },
    pl: {
        email: 'E-mail',
        avatar: 'Avatar',
        nick_name: 'Nazwa użytkownika',
        gender: 'Płeć',
        gender_male: 'Mężczyzna',
        gender_female: 'Kobieta',
        gender_other: 'Inna',
        submit: 'Zapisz',
        submitting: 'Zapisywanie...',
        editAvatar: 'Edytuj avatar',
        submitSuccess: 'Zapisano',
        tip: 'Wskazówka',
        cancel: 'Anuluj',
        confirm: 'Potwierdź',
        optional: 'Opcjonalnie',
        deleteAccount: 'Usuń konto',
        deleteAccountConfirm: 'Czy na pewno chcesz usunąć konto? Dane nie będą mogły zostać odzyskane.',
        deleteAccountTip: 'Przejdź do Ustawienia konta → Centrum bezpieczeństwa, aby złożyć wniosek o usunięcie.',
    },
    es: {
        email: 'Correo electrónico',
        avatar: 'Avatar',
        nick_name: 'Nickname',
        gender: 'Género',
        gender_male: 'Hombre',
        gender_female: 'Mujer',
        gender_other: 'Otro',
        submit: 'Enviar',
        submitting: 'Enviando',
        editAvatar: 'Editar Avatar',
        submitSuccess: 'Enviar exitosamente',
        tip: 'Sugerencia',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        optional: 'Opcional',
        deleteAccount: 'Eliminar cuenta',
        deleteAccountConfirm: '¿Está seguro de que desea eliminar su cuenta? Los datos no se podrán recuperar.',
        deleteAccountTip: 'Vaya a Configuración de la cuenta → Centro de seguridad para enviar la solicitud.',
    },
    fr: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Nickname',
        gender: 'Genre',
        gender_male: 'Homme',
        gender_female: 'Femme',
        gender_other: 'Autre',
        submit: 'Envoyer',
        submitting: 'Envoi en cours',
        editAvatar: 'Modifier Avatar',
        submitSuccess: 'Envoyer avec succès',
        tip: 'Suggestion',
        cancel: 'Annuler',
        confirm: 'Confirmer',
        optional: 'Optionnel',
        deleteAccount: 'Supprimer le compte',
        deleteAccountConfirm: 'Voulez-vous vraiment supprimer votre compte ? Les données ne pourront pas être récupérées.',
        deleteAccountTip: 'Allez dans Paramètres du compte → Centre de sécurité pour soumettre une demande.',
    },
    de: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Nickname',
        gender: 'Geschlecht',
        gender_male: 'Männlich',
        gender_female: 'Weiblich',
        gender_other: 'Sonstige',
        submit: 'Absenden',
        submitting: 'Absenden in Progress',
        editAvatar: 'Avatar bearbeiten',
        submitSuccess: 'Absenden erfolgreich',
        tip: 'Tip',
        cancel: 'Abbrechen',
        confirm: 'Bestätigen',
        optional: 'Optional',
        deleteAccount: 'Konto löschen',
        deleteAccountConfirm: 'Möchten Sie Ihr Konto wirklich löschen? Daten können nicht wiederhergestellt werden.',
        deleteAccountTip: 'Gehen Sie zu Kontoeinstellungen → Sicherheitscenter, um eine Löschung zu beantragen.',
    },
    ru: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Nickname',
        gender: 'Пол',
        gender_male: 'Мужской',
        gender_female: 'Женский',
        gender_other: 'Другое',
        submit: 'Отправить',
        submitting: 'Отправка в процессе',
        editAvatar: 'Изменить аватар',
        submitSuccess: 'Отправить успешно',
        tip: 'Подсказка',
        cancel: 'Отмена',
        confirm: 'Подтвердить',
        optional: 'Необязательно',
        deleteAccount: 'Удалить аккаунт',
        deleteAccountConfirm: 'Вы уверены, что хотите удалить аккаунт? Данные нельзя будет восстановить.',
        deleteAccountTip: 'Перейдите в Настройки → Безопасность, чтобы подать заявку на удаление.',
    },
    pt: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Nickname',
        gender: 'Gênero',
        gender_male: 'Masculino',
        gender_female: 'Feminino',
        gender_other: 'Outro',
        submit: 'Enviar',
        submitting: 'Envio em andamento',
        editAvatar: 'Editar Avatar',
        submitSuccess: 'Enviar com sucesso',
        tip: 'Sugestão',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        optional: 'Opcional',
        deleteAccount: 'Excluir conta',
        deleteAccountConfirm: 'Tem certeza de que deseja excluir sua conta? Os dados não poderão ser recuperados.',
        deleteAccountTip: 'Vá em Configurações da conta → Centro de segurança para enviar a solicitação.',
    },
    it: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Nickname',
        gender: 'Genere',
        gender_male: 'Uomo',
        gender_female: 'Donna',
        gender_other: 'Altro',
        submit: 'Invia',
        submitting: 'Invio in corso',
        editAvatar: 'Modifica Avatar',
        submitSuccess: 'Inviare con successo',
        tip: 'Suggerimento',
        cancel: 'Annulla',
        confirm: 'Conferma',
        optional: 'Opzionale',
        deleteAccount: 'Elimina account',
        deleteAccountConfirm: 'Sei sicuro di voler eliminare il tuo account? I dati non potranno essere recuperati.',
        deleteAccountTip: 'Vai in Impostazioni account → Centro sicurezza per inviare la richiesta.',
    },
    ar: {
        email: 'البريد الإلكتروني',
        avatar: 'الأيقونة',
        nick_name: 'اسم المستخدم',
        gender: 'الجنس',
        gender_male: 'ذكر',
        gender_female: 'أنثى',
        gender_other: 'آخر',
        submit: 'إرسال',
        submitting: 'جارٍ الإرسال',
        editAvatar: 'تعديل الأيقونة',
        submitSuccess: 'تم الإرسال بنجاح',
        tip: 'تلميح',
        cancel: 'إلغاء',
        confirm: 'تأكيد',
        optional: 'اختياري',
        deleteAccount: 'حذف الحساب',
        deleteAccountConfirm: 'هل أنت متأكد من حذف حسابك؟ لا يمكن استرداد البيانات بعد الحذف.',
        deleteAccountTip: 'انتقل إلى إعدادات الحساب → مركز الأمان لتقديم طلب الحذف.',
        },
    th: {
        email: 'อีเมล',
        avatar: 'อวาตาร์',
        nick_name: 'ชื่อเล่น',
        gender: 'เพศ',
        gender_male: 'ชาย',
        gender_female: 'หญิง',
        gender_other: 'อื่นๆ',
        submit: 'ส่ง',
        submitting: 'กำลังส่ง',
        editAvatar: 'แก้ไขอวาตาร์',
        submitSuccess: 'ส่งสำเร็จ',
        tip: 'คำแนะนำ',
        cancel: 'ยกเลิก',
        confirm: 'ยืนยัน',
        optional: 'ไม่บังคับ',
        deleteAccount: 'ลบบัญชี',
        deleteAccountConfirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบบัญชี? ข้อมูลจะไม่สามารถกู้คืนได้',
        deleteAccountTip: 'ไปที่ การตั้งค่าบัญชี → ศูนย์ความปลอดภัย เพื่อส่งคำขอลบ',
        },
    da: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Kaldenavn',
        gender: 'Køn',
        gender_male: 'Mand',
        gender_female: 'Kvinde',
        gender_other: 'Andet',
        submit: 'Send',
        submitting: 'Sender...',
        editAvatar: 'Rediger avatar',
        submitSuccess: 'Sendt',
        tip: 'Tip',
        cancel: 'Annuller',
        confirm: 'Bekræft',
        optional: 'Valgfri',
        deleteAccount: 'Slet konto',
        deleteAccountConfirm: 'Er du sikker på, at du vil slette din konto? Data kan ikke gendannes.',
        deleteAccountTip: 'Gå til Kontoindstillinger → Sikkerhedscenter for at indsende anmodning.',
        },
    no: {
        email: 'E-post',
        avatar: 'Avatar',
        nick_name: 'Kallenavn',
        gender: 'Kjønn',
        gender_male: 'Mann',
        gender_female: 'Kvinne',
        gender_other: 'Annet',
        submit: 'Send',
        submitting: 'Sender...',
        editAvatar: 'Rediger avatar',
        submitSuccess: 'Sendt',
        tip: 'Tips',
        cancel: 'Avbryt',
        confirm: 'Bekreft',
        optional: 'Valgfritt',
        deleteAccount: 'Slett konto',
        deleteAccountConfirm: 'Er du sikker på at du vil slette kontoen? Data kan ikke gjenopprettes.',
        deleteAccountTip: 'Gå til Kontoinnstillinger → Sikkerhetssenter for å sende forespørsel.',
        },
    nl: {
        email: 'E-mail',
        avatar: 'Avatar',
        nick_name: 'Bijnaam',
        gender: 'Geslacht',
        gender_male: 'Man',
        gender_female: 'Vrouw',
        gender_other: 'Anders',
        submit: 'Verzenden',
        submitting: 'Bezig met verzenden...',
        editAvatar: 'Avatar bewerken',
        submitSuccess: 'Verzonden',
        tip: 'Tip',
        cancel: 'Annuleren',
        confirm: 'Bevestigen',
        optional: 'Optioneel',
        deleteAccount: 'Account verwijderen',
        deleteAccountConfirm: 'Weet u zeker dat u uw account wilt verwijderen? Gegevens kunnen niet worden hersteld.',
        deleteAccountTip: 'Ga naar Accountinstellingen → Beveiligingscentrum om een verzoek in te dienen.',
    },
    id: {
        email: 'Email',
        avatar: 'Avatar',
        nick_name: 'Nama panggilan',
        gender: 'Jenis kelamin',
        gender_male: 'Laki-laki',
        gender_female: 'Perempuan',
        gender_other: 'Lainnya',
        submit: 'Kirim',
        submitting: 'Mengirim...',
        editAvatar: 'Edit avatar',
        submitSuccess: 'Berhasil dikirim',
        tip: 'Tips',
        cancel: 'Batal',
        confirm: 'Konfirmasi',
        optional: 'Opsional',
        deleteAccount: 'Hapus akun',
        deleteAccountConfirm: 'Apakah Anda yakin ingin menghapus akun? Data tidak dapat dipulihkan.',
        deleteAccountTip: 'Buka Pengaturan akun → Pusat keamanan untuk mengirim permintaan.',
    },
    tr: {
        email: 'E-posta',
        avatar: 'Avatar',
        nick_name: 'Takma ad',
        gender: 'Cinsiyet',
        gender_male: 'Erkek',
        gender_female: 'Kadın',
        gender_other: 'Diğer',
        submit: 'Gönder',
        submitting: 'Gönderiliyor...',
        editAvatar: 'Avatarı düzenle',
        submitSuccess: 'Gönderildi',
        tip: 'İpucu',
        cancel: 'İptal',
        confirm: 'Onayla',
        optional: 'İsteğe bağlı',
        deleteAccount: 'Hesabı sil',
        deleteAccountConfirm: 'Hesabınızı silmek istediğinizden emin misiniz? Veriler kurtarılamaz.',
        deleteAccountTip: 'Hesap ayarları → Güvenlik merkezine giderek talep gönderin.',
    },
}
